module.exports = __webpack_public_path__ + "img/alerts-6.0e2b363d.gif";